/* JD Gourmét — lightweight brand interactions. No dependencies. ~1KB. */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal-on-scroll for elements with .jd-reveal (no-op under reduced motion). */
  function initReveal() {
    var els = document.querySelectorAll('.jd-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('jd-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('jd-in');
            io.unobserve(entry.target);
          }
        });
      },
      /* Positive bottom margin grows the root so below-fold reveals fire
         slightly BEFORE entering view (pre-fire). */
      { rootMargin: '0px 0px 10% 0px', threshold: 0.08 }
    );
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      /* Anything already within the viewport at load paints already-revealed,
         WITHOUT the entrance transition — kills the above-the-fold flash.
         The transition is declared on `.jd-reveal.jd-in`, so suppress it inline
         (higher specificity), commit the revealed state, force a reflow, then
         clear the inline override so later state changes (theme-editor
         re-renders) still animate. */
      var rect = el.getBoundingClientRect();
      var inView = rect.top < vh && rect.bottom > 0;
      if (inView) {
        el.style.transition = 'none';
        el.classList.add('jd-in');
        void el.offsetWidth; /* force reflow so the no-transition state commits */
        el.style.transition = '';
        return;
      }
      io.observe(el);
    });
  }

  /* Expose a tiny namespace so section scripts can share the observer pattern. */
  window.JD = window.JD || {};
  window.JD.reduceMotion = reduceMotion;
  window.JD.refreshReveal = initReveal;

  if (document.readyState !== 'loading') initReveal();
  else document.addEventListener('DOMContentLoaded', initReveal);

  /* Re-init reveals when sections are re-rendered in the theme editor. */
  document.addEventListener('shopify:section:load', initReveal);
})();
